import React, { useEffect } from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';
import PrivateRoute from 'js/components/route_utils/PrivateRoute';
import { ROUTE_ACCESS_INSIGHTS, ROUTE_COLLABORATE } from 'new/constants/pathnames';
import Drawer from '../drawer/Drawer';
import { useDispatch } from 'react-redux';
import { fetchAllOrgs } from 'js/actions/orgs';
import { router } from 'new/routes/router';
import structure, { StructureGroup } from 'new/routes/structure';
import { ThunkDispatch } from 'redux-thunk';
import { Action } from 'redux';
import { useSectionNavigation, useLastVisitedPath } from 'new/hooks/useSectionNavigation';

const SIDEBAR_GROUPS = structure.find((s) => s.name === 'Collaborate').groups();

export function Collaborate() {
  const dispatch = useDispatch<ThunkDispatch<any, any, Action>>();
  useSectionNavigation('collaborate');

  useEffect(() => {
    dispatch(fetchAllOrgs());
  }, []);

  const defaultPath = ROUTE_ACCESS_INSIGHTS;
  const lastVisitedPath = useLastVisitedPath('collaborate', ROUTE_COLLABORATE, defaultPath);

  return (
    <Drawer content={SIDEBAR_GROUPS as StructureGroup[]}>
      <Switch>
        {Object.keys(router.routesNames.collaborate).map((routeName) => (
          <PrivateRoute key={routeName} {...router.manager.getRoute(routeName, 'collaborate')} />
        ))}
        <Route path="*">
          {lastVisitedPath ? <Redirect to={lastVisitedPath} /> : <Redirect to={defaultPath} />}
        </Route>
      </Switch>
    </Drawer>
  );
}
